// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1YujM","detailsBorder":"styles_detailsBorder__3URs5"};